import React from "react";
import PropTypes from "prop-types";

export function FacebookIcon() {
  return (
    <svg
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1505_255)">
        <path
          d="M29.9758 15C29.9758 23.0081 23.4839 29.5 15.4758 29.5C7.4677 29.5 0.97583 23.0081 0.97583 15C0.97583 6.99187 7.4677 0.5 15.4758 0.5C23.4839 0.5 29.9758 6.99187 29.9758 15Z"
          fill="#161616"
          stroke="#454545"
        />
        <path
          d="M16.7804 22.4936V15.938H18.9672L19.3819 13.2279H16.7804V11.4656C16.7804 10.7252 17.1457 9.9995 18.3107 9.9995H19.4954V7.68924C19.4954 7.68924 18.4193 7.50659 17.3974 7.50659C15.255 7.50659 13.8531 8.80488 13.8531 11.1546V13.223H11.4688V15.9331H13.8531V22.4887H16.7853L16.7804 22.4936Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1505_255">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(0.47583)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export function RedCrosss() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="20"
      height="20"
      fill="red"
    >
      <path
        d="M6 6L18 18M6 18L18 6"
        stroke="red"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function TwitterIcon() {
  return (
    <svg
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1505_252)">
        <path
          d="M30.1855 15C30.1855 23.0081 23.6937 29.5 15.6855 29.5C7.67741 29.5 1.18555 23.0081 1.18555 15C1.18555 6.99187 7.67741 0.5 15.6855 0.5C23.6937 0.5 30.1855 6.99187 30.1855 15Z"
          fill="#161616"
          stroke="#454545"
        />
        <path
          d="M16.9212 13.9783L21.7537 8.35669H20.6098L16.4135 13.2381L13.0613 8.35669H9.19531L14.2664 15.7339L9.19531 21.6246H10.3392L14.7741 16.474L18.3159 21.6246H22.1819L16.9212 13.9722V13.9783ZM15.3552 15.8012L14.8414 15.0671L10.7552 9.2192H12.5169L15.814 13.9355L16.3278 14.6695L20.6159 20.8049H18.8542L15.3552 15.8012Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1505_252">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(0.685547)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export function DelegatorStake() {
  return (
    <svg
      width="51"
      height="51"
      viewBox="0 0 51 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1.16675" y="1" width="49" height="49" rx="24.5" fill="#FDFD1F" />
      <rect
        x="1.16675"
        y="1"
        width="49"
        height="49"
        rx="24.5"
        stroke="#FDFD1F"
      />
      <path
        d="M23.5436 25.3286C23.3249 25.3103 23.1075 25.2795 22.8924 25.2363L22.0813 31.0928C22.0509 31.3017 22.0657 31.5147 22.1245 31.7175C22.1834 31.9202 22.285 32.108 22.4225 32.2683L23.4704 33.3311C23.5453 33.4074 23.6346 33.4679 23.7332 33.5092C23.8317 33.5505 23.9375 33.5718 24.0443 33.5718C24.1512 33.5718 24.257 33.5505 24.3555 33.5092C24.454 33.4679 24.5434 33.4074 24.6182 33.3311L25.6665 32.2681C25.8037 32.1089 25.9038 31.9212 25.9598 31.7187C26.0159 31.5162 26.0263 31.3037 25.9905 31.0967L25.0202 25.2657C24.8038 25.3034 24.5854 25.3286 24.3662 25.3413L25.3435 31.2137C25.3599 31.3172 25.3556 31.423 25.3306 31.5248C25.3057 31.6266 25.2606 31.7223 25.1982 31.8065L24.15 32.8694C24.1363 32.8836 24.1199 32.8948 24.1017 32.9025C24.0836 32.9102 24.064 32.9142 24.0443 32.9142C24.0246 32.9142 24.0051 32.9102 23.9869 32.9025C23.9687 32.8948 23.9523 32.8836 23.9386 32.8694L22.8908 31.8065C22.7594 31.63 22.7022 31.409 22.7315 31.1909L23.5436 25.3286Z"
        fill="black"
        stroke="black"
        strokeWidth="0.8"
      />
      <path
        d="M24.0384 24.6935C25.0465 24.6935 26.0319 24.3946 26.87 23.8346C27.7082 23.2745 28.3614 22.4785 28.7472 21.5472C29.133 20.6159 29.2339 19.5911 29.0372 18.6024C28.8406 17.6138 28.3552 16.7056 27.6424 15.9928C26.9296 15.28 26.0214 14.7946 25.0327 14.5979C24.0441 14.4013 23.0193 14.5022 22.088 14.888C21.1567 15.2737 20.3606 15.927 19.8006 16.7652C19.2406 17.6033 18.9417 18.5887 18.9417 19.5968C18.9432 20.948 19.4806 22.2435 20.4361 23.199C21.3916 24.1545 22.6871 24.692 24.0384 24.6935ZM24.0384 15.1576C24.9164 15.1576 25.7746 15.418 26.5046 15.9058C27.2347 16.3935 27.8036 17.0868 28.1396 17.898C28.4756 18.7091 28.5635 19.6017 28.3922 20.4628C28.2209 21.3239 27.7982 22.1149 27.1773 22.7357C26.5565 23.3565 25.7655 23.7793 24.9044 23.9506C24.0433 24.1219 23.1508 24.0339 22.3396 23.698C21.5285 23.362 20.8352 22.793 20.3474 22.063C19.8596 21.333 19.5993 20.4747 19.5993 19.5968C19.6006 18.4198 20.0688 17.2915 20.901 16.4593C21.7332 15.6271 22.8615 15.159 24.0384 15.1576Z"
        fill="black"
        stroke="black"
        strokeWidth="0.8"
      />
      <path
        d="M27.6958 24.0361C27.389 24.2889 27.0569 24.5093 26.7048 24.6938H28.0481C30.1111 24.6938 31.6467 25.6854 32.3413 27.3441C32.5938 27.3674 32.8438 27.4125 33.0885 27.4787C32.3764 25.3584 30.5272 24.0361 28.0481 24.0361H27.6958Z"
        fill="black"
        stroke="black"
        strokeWidth="0.8"
      />
      <path
        d="M15.6532 34.8873C15.566 34.8872 15.4825 34.8525 15.4208 34.7909C15.3592 34.7292 15.3245 34.6456 15.3244 34.5585V29.5386C15.3244 26.5954 17.1711 24.6938 20.0291 24.6938H21.3715C21.0194 24.5093 20.6873 24.2889 20.3805 24.0361H20.0291C16.8218 24.0361 14.6667 26.2473 14.6667 29.5386V34.5585C14.667 34.82 14.7711 35.0708 14.956 35.2557C15.1409 35.4406 15.3917 35.5447 15.6532 35.5449H29.608C29.3068 35.3593 29.0287 35.1385 28.7795 34.8873H15.6532Z"
        fill="black"
        stroke="black"
        strokeWidth="0.8"
      />
      <path
        d="M31.9301 27.9814C31.1822 27.9814 30.4511 28.2032 29.8293 28.6187C29.2074 29.0342 28.7227 29.6248 28.4365 30.3158C28.1503 31.0068 28.0754 31.7671 28.2213 32.5006C28.3673 33.2342 28.7274 33.908 29.2562 34.4368C29.7851 34.9657 30.4589 35.3258 31.1924 35.4717C31.926 35.6176 32.6863 35.5427 33.3773 35.2565C34.0682 34.9703 34.6588 34.4856 35.0743 33.8638C35.4898 33.2419 35.7116 32.5108 35.7116 31.7629C35.7105 30.7603 35.3117 29.7992 34.6028 29.0902C33.8939 28.3813 32.9327 27.9826 31.9301 27.9814ZM31.9301 34.8867C31.3123 34.8867 30.7084 34.7035 30.1946 34.3603C29.6809 34.017 29.2806 33.5291 29.0441 32.9583C28.8077 32.3875 28.7458 31.7594 28.8664 31.1535C28.9869 30.5475 29.2844 29.9909 29.7213 29.554C30.1581 29.1172 30.7148 28.8196 31.3207 28.6991C31.9267 28.5786 32.5548 28.6404 33.1256 28.8769C33.6964 29.1133 34.1843 29.5137 34.5275 30.0274C34.8708 30.5411 35.054 31.1451 35.054 31.7629C35.053 32.5911 34.7236 33.3851 34.138 33.9707C33.5524 34.5564 32.7583 34.8858 31.9301 34.8867Z"
        fill="black"
        stroke="black"
        strokeWidth="0.8"
      />
      <path
        d="M33.3887 30.6698L31.2192 32.151L30.5313 31.38C30.5025 31.3478 30.4677 31.3215 30.4288 31.3028C30.3899 31.284 30.3477 31.2731 30.3045 31.2706C30.2614 31.2682 30.2182 31.2743 30.1775 31.2885C30.1367 31.3027 30.0991 31.3249 30.0669 31.3536C30.0347 31.3824 30.0084 31.4172 29.9897 31.4561C29.9709 31.495 29.96 31.5372 29.9576 31.5804C29.9551 31.6235 29.9612 31.6667 29.9754 31.7074C29.9897 31.7482 30.0118 31.7858 30.0406 31.818L30.9209 32.8045C30.9747 32.8632 31.0476 32.9008 31.1266 32.9104C31.2056 32.92 31.2854 32.9011 31.3517 32.857L33.7596 31.2129C33.7953 31.1885 33.8259 31.1574 33.8496 31.1213C33.8732 31.0851 33.8896 31.0446 33.8976 31.0022C33.9056 30.9597 33.9052 30.9161 33.8964 30.8738C33.8875 30.8315 33.8704 30.7913 33.846 30.7557C33.8217 30.72 33.7905 30.6894 33.7543 30.6658C33.7181 30.6422 33.6776 30.6259 33.6352 30.6179C33.5927 30.61 33.5491 30.6105 33.5068 30.6194C33.4645 30.6283 33.4244 30.6454 33.3887 30.6698Z"
        fill="black"
        stroke="black"
        strokeWidth="0.8"
      />
    </svg>
  );
}
export function TotalReward() {
  return (
    <svg
      width="50"
      height="51"
      viewBox="0 0 50 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="1"
        width="49"
        height="49"
        rx="24.5"
        fill="#FDFD1F"
        stroke="#FDFD1F"
      />
      <path
        d="M36.9167 20.0831C36.9161 19.8831 36.8601 19.6871 36.755 19.5169C36.6498 19.3467 36.4995 19.209 36.3209 19.119L25.4876 13.7023C25.3363 13.6261 25.1694 13.5864 25.0001 13.5864C24.8307 13.5864 24.6638 13.6261 24.5126 13.7023L13.6792 19.119C13.5018 19.2099 13.3528 19.348 13.2489 19.5181C13.1449 19.6882 13.0898 19.8838 13.0898 20.0831C13.0898 20.2825 13.1449 20.478 13.2489 20.6482C13.3528 20.8183 13.5018 20.9564 13.6792 21.0473L17.1567 22.7915L13.6792 24.5356C13.5018 24.6266 13.3528 24.7647 13.2489 24.9348C13.1449 25.1049 13.0898 25.3004 13.0898 25.4998C13.0898 25.6992 13.1449 25.8947 13.2489 26.0648C13.3528 26.2349 13.5018 26.3731 13.6792 26.464L17.1567 28.2081L13.6792 29.9523C13.5018 30.0432 13.3528 30.1813 13.2489 30.3515C13.1449 30.5216 13.0898 30.7171 13.0898 30.9165C13.0898 31.1159 13.1449 31.3114 13.2489 31.4815C13.3528 31.6516 13.5018 31.7897 13.6792 31.8806L24.5126 37.2973C24.6638 37.3735 24.8307 37.4132 25.0001 37.4132C25.1694 37.4132 25.3363 37.3735 25.4876 37.2973L36.3209 31.8806C36.4983 31.7897 36.6473 31.6516 36.7512 31.4815C36.8552 31.3114 36.9103 31.1159 36.9103 30.9165C36.9103 30.7171 36.8552 30.5216 36.7512 30.3515C36.6473 30.1813 36.4983 30.0432 36.3209 29.9523L32.8434 28.2081L36.3209 26.464C36.4983 26.3731 36.6473 26.2349 36.7512 26.0648C36.8552 25.8947 36.9103 25.6992 36.9103 25.4998C36.9103 25.3004 36.8552 25.1049 36.7512 24.9348C36.6473 24.7647 36.4983 24.6266 36.3209 24.5356L32.8434 22.7915L36.3209 21.0473C36.4995 20.9573 36.6498 20.8195 36.755 20.6494C36.8601 20.4792 36.9161 20.2832 36.9167 20.0831ZM33.4067 30.9165L25.0001 35.1198L16.5934 30.9165L19.5834 29.4215L24.5126 31.8806C24.6638 31.9568 24.8307 31.9965 25.0001 31.9965C25.1694 31.9965 25.3363 31.9568 25.4876 31.8806L30.4167 29.4215L33.4067 30.9165ZM33.4067 25.4998L25.0001 29.7031L16.5934 25.4998L19.5834 24.0048L24.5126 26.464C24.6638 26.5402 24.8307 26.5799 25.0001 26.5799C25.1694 26.5799 25.3363 26.5402 25.4876 26.464L30.4167 24.0048L33.4067 25.4998ZM25.0001 24.2865L16.5934 20.0831L25.0001 15.8798L33.4067 20.0831L25.0001 24.2865Z"
        fill="black"
        stroke="black"
        strokeWidth="0.3"
      />
    </svg>
  );
}
export function BlockProposed() {
  return (
    <svg
      width="51"
      height="51"
      viewBox="0 0 51 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.833496"
        y="1"
        width="49"
        height="49"
        rx="24.5"
        fill="#FDFD1F"
        stroke="#FDFD1F"
      />
      <g clip-path="url(#clip0_675_6424)">
        <path
          d="M33.8335 37.5H16.8335C16.0065 37.5 15.3335 36.827 15.3335 36V26C15.3335 25.724 15.5575 25.5 15.8335 25.5H34.8335C35.1095 25.5 35.3335 25.724 35.3335 26V36C35.3335 36.827 34.6605 37.5 33.8335 37.5ZM16.3335 26.5V36C16.3335 36.275 16.5585 36.5 16.8335 36.5H33.8335C34.1085 36.5 34.3335 36.275 34.3335 36V26.5H16.3335Z"
          fill="black"
        />
        <path
          d="M35.8335 26.5H14.8335C14.0065 26.5 13.3335 25.827 13.3335 25V22C13.3335 21.173 14.0065 20.5 14.8335 20.5H35.8335C36.6605 20.5 37.3335 21.173 37.3335 22V25C37.3335 25.827 36.6605 26.5 35.8335 26.5ZM14.8335 21.5C14.5585 21.5 14.3335 21.725 14.3335 22V25C14.3335 25.275 14.5585 25.5 14.8335 25.5H35.8335C36.1085 25.5 36.3335 25.275 36.3335 25V22C36.3335 21.725 36.1085 21.5 35.8335 21.5H14.8335Z"
          fill="black"
        />
        <path
          d="M25.3335 21.5C25.1885 21.5 25.0505 21.438 24.9555 21.327C24.8605 21.218 24.8175 21.073 24.8385 20.93C24.8495 20.855 25.9675 13.5 31.8335 13.5C34.4175 13.5 35.3345 14.896 35.3345 16.091C35.3345 18.337 32.2315 21.5 25.3335 21.5ZM31.8335 14.5C27.7215 14.5 26.3195 18.885 25.9445 20.49C31.4235 20.32 34.3345 17.874 34.3345 16.091C34.3345 15.647 34.1475 15.281 33.7805 15.006C33.3405 14.675 32.6665 14.5 31.8335 14.5Z"
          fill="black"
        />
        <path
          d="M25.3345 21.5C18.4365 21.5 15.3335 18.337 15.3335 16.091C15.3335 15.337 15.6725 14.667 16.2865 14.206C16.9015 13.744 17.7825 13.5 18.8345 13.5C24.7005 13.5 25.8185 20.855 25.8295 20.93C25.8505 21.074 25.8075 21.218 25.7125 21.327C25.6175 21.438 25.4795 21.5 25.3345 21.5ZM18.8345 14.5C17.2915 14.5 16.3335 15.109 16.3335 16.091C16.3335 17.875 19.2465 20.321 24.7285 20.491C24.3655 18.876 22.9985 14.5 18.8345 14.5Z"
          fill="black"
        />
        <path
          d="M25.3335 37.5C25.0575 37.5 24.8335 37.276 24.8335 37V21C24.8335 20.724 25.0575 20.5 25.3335 20.5C25.6095 20.5 25.8335 20.724 25.8335 21V37C25.8335 37.276 25.6095 37.5 25.3335 37.5Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_675_6424">
          <rect
            width="24"
            height="24"
            fill="black"
            transform="translate(13.3335 13.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export function InstaIcon() {
  return (
    <svg
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1505_247)">
        <path
          d="M30.3955 15C30.3955 23.0081 23.9036 29.5 15.8955 29.5C7.88737 29.5 1.39551 23.0081 1.39551 15C1.39551 6.99187 7.88737 0.5 15.8955 0.5C23.9036 0.5 30.3955 6.99187 30.3955 15Z"
          fill="#161616"
          stroke="#454545"
        />
        <path
          d="M20.0311 9.98315C19.5276 9.98315 19.1184 10.3923 19.1184 10.8959C19.1184 11.3994 19.5276 11.8086 20.0311 11.8086C20.5347 11.8086 20.9438 11.3994 20.9438 10.8959C20.9438 10.3923 20.5347 9.98315 20.0311 9.98315Z"
          fill="white"
        />
        <path
          d="M15.9585 11.1541C13.8373 11.1541 12.1125 12.8788 12.1125 15C12.1125 17.1213 13.8373 18.846 15.9585 18.846C18.0798 18.846 19.8045 17.1213 19.8045 15C19.8045 12.8788 18.0798 11.1541 15.9585 11.1541ZM15.9585 17.4612C14.5989 17.4612 13.4974 16.3534 13.4974 15C13.4974 13.6467 14.6052 12.5389 15.9585 12.5389C17.3119 12.5389 18.4197 13.6467 18.4197 15C18.4197 16.3534 17.3119 17.4612 15.9585 17.4612Z"
          fill="white"
        />
        <path
          d="M19.0114 22.8054H12.7798C10.1927 22.8054 8.09033 20.703 8.09033 18.1159V11.8843C8.09033 9.29721 10.1927 7.19482 12.7798 7.19482H19.0114C21.5985 7.19482 23.7009 9.29721 23.7009 11.8843V18.1159C23.7009 20.703 21.5985 22.8054 19.0114 22.8054ZM19.0114 21.3387C20.7865 21.3387 22.2343 19.891 22.2343 18.1159V11.8843C22.2343 10.1092 20.7865 8.66146 19.0114 8.66146H12.7798C11.0047 8.66146 9.55697 10.1092 9.55697 11.8843V18.1159C9.55697 19.891 11.0047 21.3387 12.7798 21.3387H19.0114Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1505_247">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(0.895508)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export function SocialIcon() {
  return (
    <svg
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1505_244)">
        <path
          d="M29.6052 15C29.6052 23.0081 23.1133 29.5 15.1052 29.5C7.09709 29.5 0.605225 23.0081 0.605225 15C0.605225 6.99187 7.09709 0.5 15.1052 0.5C23.1133 0.5 29.6052 6.99187 29.6052 15Z"
          fill="#161616"
          stroke="#454545"
        />
        <path
          d="M18.9469 9.83858C18.3761 9.18676 18.0616 8.34981 18.0616 7.4834H15.481V17.8395C15.4615 18.4001 15.225 18.9312 14.8214 19.3207C14.4179 19.7103 13.8788 19.9278 13.3179 19.9275C12.1319 19.9275 11.1464 18.9587 11.1464 17.756C11.1464 16.3195 12.5328 15.2421 13.9609 15.6848V13.0456C11.0796 12.6615 8.55737 14.8997 8.55737 17.756C8.55737 20.5371 10.8624 22.5165 13.3095 22.5165C15.9319 22.5165 18.0616 20.3868 18.0616 17.756V12.5028C19.1081 13.2543 20.3645 13.6575 21.6529 13.6553V11.0746C21.6529 11.0746 20.0828 11.1498 18.9469 9.83858Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1505_244">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(0.105225)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export function TelegramIcon() {
  return (
    <svg
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1505_241)">
        <path
          d="M29.8149 15C29.8149 23.0081 23.3231 29.5 15.3149 29.5C7.30681 29.5 0.814941 23.0081 0.814941 15C0.814941 6.99187 7.30681 0.5 15.3149 0.5C23.3231 0.5 29.8149 6.99187 29.8149 15Z"
          fill="#161616"
          stroke="#454545"
        />
        <path
          d="M7.88903 14.7902C7.88903 14.7902 14.2103 12.197 16.4058 11.2796C17.2437 10.9136 20.0967 9.74697 20.0967 9.74697C20.0967 9.74697 21.4119 9.23787 21.3005 10.4788C21.2634 10.9879 20.9717 12.7803 20.68 14.7159C20.2399 17.4576 19.7679 20.4539 19.7679 20.4539C19.7679 20.4539 19.6937 21.2971 19.0732 21.4402C18.4528 21.5887 17.4293 20.9312 17.2437 20.7827C17.0952 20.6713 14.502 19.0273 13.5527 18.2266C13.2982 18.0092 13.0065 17.569 13.5898 17.0546C14.905 15.8508 16.4747 14.35 17.4293 13.4008C17.8694 12.9606 18.3043 11.9371 16.48 13.1834C13.8868 14.9758 11.3254 16.6569 11.3254 16.6569C11.3254 16.6569 10.7421 17.0228 9.64435 16.694C8.54661 16.3652 7.26857 15.925 7.26857 15.925C7.26857 15.925 6.39356 15.3788 7.88903 14.7902Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1505_241">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(0.314941)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export function DiscordIcon() {
  return (
    <svg
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1505_238)">
        <path
          d="M30.0249 15C30.0249 23.0081 23.533 29.5 15.5249 29.5C7.51677 29.5 1.0249 23.0081 1.0249 15C1.0249 6.99187 7.51677 0.5 15.5249 0.5C23.533 0.5 30.0249 6.99187 30.0249 15Z"
          fill="#161616"
          stroke="#454545"
        />
        <path
          d="M21.3902 9.64043C20.2791 9.12977 19.1118 8.77062 17.9053 8.56299C17.7538 8.83235 17.5799 9.1915 17.462 9.47769C16.1826 9.28689 14.8807 9.28689 13.6012 9.47769C13.4665 9.16344 13.3094 8.86041 13.141 8.56299C11.9345 8.76501 10.7617 9.12977 9.65619 9.64604C7.45641 12.9233 6.86157 16.1219 7.15899 19.2757C8.44968 20.2353 9.89749 20.9648 11.4351 21.4305C11.783 20.9592 12.086 20.4653 12.3498 19.9435C11.8503 19.7583 11.3677 19.5282 10.9076 19.2532C11.0254 19.1634 11.1433 19.0736 11.2555 18.9782C13.9603 20.2577 17.0973 20.2577 19.8077 18.9782C19.9199 19.0736 20.0434 19.1634 20.1612 19.2532C19.7011 19.5282 19.2185 19.7583 18.719 19.9435C18.9828 20.4597 19.2914 20.9592 19.6337 21.4249C21.1713 20.9592 22.6191 20.2297 23.9098 19.2701C24.2577 15.6169 23.3094 12.4463 21.3958 9.63482L21.3902 9.64043ZM12.7202 17.3396C11.884 17.3396 11.205 16.5765 11.205 15.6393C11.205 14.7022 11.8728 13.9334 12.7202 13.9334C13.5675 13.9334 14.2465 14.6965 14.2409 15.6337C14.2353 16.5708 13.5731 17.3396 12.7202 17.3396ZM18.3318 17.3396C17.4957 17.3396 16.8167 16.5765 16.8167 15.6393C16.8167 14.7022 17.4845 13.9334 18.3318 13.9334C19.1792 13.9334 19.8582 14.6965 19.847 15.6337C19.8358 16.5708 19.1792 17.3396 18.3318 17.3396Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1505_238">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(0.524902)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export function NotFoundIcon() {
  return (
    <svg
      width="90"
      height="90"
      viewBox="0 0 195 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.3">
        <path
          d="M142.88 18.0908V169.788H35.499V181.848H154.615V18.0908H142.88Z"
          fill="#050308"
        />
        <path
          d="M54.0443 6.18164L23.9116 37.1513V169.939H143.027V6.18164H54.0443Z"
          fill="#050308"
        />
        <path
          d="M92.5506 157.213C116.113 157.213 135.214 137.581 135.214 113.364C135.214 89.1473 116.113 69.5156 92.5506 69.5156C68.9883 69.5156 49.8872 89.1473 49.8872 113.364C49.8872 137.581 68.9883 157.213 92.5506 157.213Z"
          fill="#050308"
        />
        <path d="M53.8968 37V6.03027L23.7642 37H53.8968Z" fill="#050308" />
        <path
          d="M70.5258 24.8179H126.398C127.607 24.8179 128.609 23.7876 128.609 22.5452C128.609 21.3028 127.607 20.2725 126.398 20.2725H70.5258C69.3169 20.2725 68.3145 21.3028 68.3145 22.5452C68.3145 23.7876 69.3169 24.8179 70.5258 24.8179Z"
          fill="white"
        />
        <path
          d="M126.428 38.8184H70.4965C69.2876 38.8184 68.2852 39.8487 68.2852 41.0911C68.2852 42.3335 69.2876 43.3638 70.4965 43.3638H126.428C127.637 43.3638 128.639 42.3335 128.639 41.0911C128.639 39.8487 127.637 38.8184 126.428 38.8184Z"
          fill="white"
        />
        <path
          d="M126.428 150.094H38.4965C37.2876 150.094 36.2852 151.124 36.2852 152.366C36.2852 153.609 37.2876 154.639 38.4965 154.639H126.428C127.637 154.639 128.639 153.609 128.639 152.366C128.639 151.124 127.637 150.094 126.428 150.094Z"
          fill="white"
        />
        <path
          d="M126.428 131.548H38.4965C37.2876 131.548 36.2852 132.578 36.2852 133.821C36.2852 135.063 37.2876 136.093 38.4965 136.093H126.428C127.637 136.093 128.639 135.063 128.639 133.821C128.639 132.578 127.637 131.548 126.428 131.548Z"
          fill="white"
        />
        <path
          d="M126.428 113.002H38.4965C37.2876 113.002 36.2852 114.032 36.2852 115.275C36.2852 116.517 37.2876 117.547 38.4965 117.547H126.428C127.637 117.547 128.639 116.517 128.639 115.275C128.639 114.032 127.637 113.002 126.428 113.002Z"
          fill="white"
        />
        <path
          d="M126.428 94.4561H38.4965C37.2876 94.4561 36.2852 95.4864 36.2852 96.7288C36.2852 97.9712 37.2876 99.0015 38.4965 99.0015H126.428C127.637 99.0015 128.639 97.9712 128.639 96.7288C128.639 95.4864 127.637 94.4561 126.428 94.4561Z"
          fill="white"
        />
        <path
          d="M126.428 75.9102H38.4965C37.2876 75.9102 36.2852 76.9405 36.2852 78.1829C36.2852 79.4253 37.2876 80.4556 38.4965 80.4556H126.428C127.637 80.4556 128.639 79.4253 128.639 78.1829C128.639 76.9405 127.637 75.9102 126.428 75.9102Z"
          fill="white"
        />
        <path
          d="M126.428 57.3643H38.4965C37.2876 57.3643 36.2852 58.3946 36.2852 59.637C36.2852 60.8794 37.2876 61.9097 38.4965 61.9097H126.428C127.637 61.9097 128.639 60.8794 128.639 59.637C128.639 58.3946 127.637 57.3643 126.428 57.3643Z"
          fill="white"
        />
        <path
          d="M154.445 179.818H37.7102V172.303H142.71C143.919 172.303 144.921 171.273 144.921 170.031C144.921 168.788 143.919 167.758 142.71 167.758H25.946V39.3335H53.8969C55.1057 39.3335 56.1082 38.3032 56.1082 37.0608V8.33354H140.786V169.849C140.786 171.091 141.789 172.121 142.998 172.121C144.206 172.121 145.209 171.091 145.209 169.849V20.3941H152.521V182.037C152.521 183.279 153.523 184.31 154.732 184.31C155.941 184.31 156.944 183.279 156.944 182.037V18.1214C156.944 16.879 155.941 15.8487 154.732 15.8487H145.209V6.06081C145.209 4.81839 144.206 3.78809 142.998 3.78809H53.9264C53.3367 3.78809 52.7765 4.03051 52.3637 4.45475L22.1721 35.4548C21.7593 35.879 21.5234 36.4548 21.5234 37.0608V170C21.5234 171.243 22.5259 172.273 23.7347 172.273H33.2581V182.061C33.2581 183.303 34.2605 184.334 35.4694 184.334H154.415C155.624 184.334 156.627 183.303 156.627 182.061C156.627 180.818 155.654 179.818 154.445 179.818ZM51.7151 11.5457V34.7881H29.0713L51.7151 11.5457Z"
          fill="white"
        />
      </g>
    </svg>
  );
}
export function Magnifier() {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.7337 20.3329L15.447 15.0462"
        stroke="#565656"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.7338 16.9995C14.4157 16.9995 17.4005 14.0148 17.4005 10.3329C17.4005 6.65098 14.4157 3.66621 10.7338 3.66621C7.05191 3.66621 4.06714 6.65098 4.06714 10.3329C4.06714 14.0148 7.05191 16.9995 10.7338 16.9995Z"
        stroke="#565656"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function SelfStake() {
  return (
    <svg
      width="51"
      height="51"
      viewBox="0 0 51 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.16675"
        y="1"
        width="49"
        height="49"
        rx="24.5"
        fill="#FDFD1F"
        stroke="#FDFD1F"
      />
      <path
        d="M30.2988 27.7959L26.6737 25.077V19.5387C26.6737 18.9819 26.2235 18.5317 25.6667 18.5317C25.1098 18.5317 24.6597 18.9819 24.6597 19.5387V25.5806C24.6597 25.8978 24.8087 26.1969 25.0625 26.3862L29.0903 29.4071C29.2716 29.543 29.4831 29.6085 29.6935 29.6085C30.0006 29.6085 30.3027 29.4705 30.5001 29.2047C30.8345 28.7606 30.7439 28.1292 30.2988 27.7959Z"
        fill="black"
        stroke="black"
        strokeWidth="0.3"
      />
      <path
        d="M25.6667 12.5C18.4981 12.5 12.6667 18.3314 12.6667 25.5C12.6667 32.6686 18.4981 38.5 25.6667 38.5C32.8354 38.5 38.6667 32.6686 38.6667 25.5C38.6667 18.3314 32.8354 12.5 25.6667 12.5ZM25.6667 36.4861C19.6098 36.4861 14.6807 31.5569 14.6807 25.5C14.6807 19.4431 19.6098 14.5139 25.6667 14.5139C31.7247 14.5139 36.6528 19.4431 36.6528 25.5C36.6528 31.5569 31.7237 36.4861 25.6667 36.4861Z"
        fill="black"
        stroke="black"
        strokeWidth="0.3"
      />
    </svg>
  );
}
export function BlockIcon() {
  return (
    <svg
      width="50"
      height="51"
      viewBox="0 0 50 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="1"
        width="49"
        height="49"
        rx="24.5"
        fill="#FDFD1F"
        stroke="#FDFD1F"
      />
      <g clip-path="url(#clip0_675_6374)">
        <path
          d="M24.5212 12.5835L13.2627 19.0835V32.0834L24.5212 38.5835L35.7794 32.0834V19.0835L24.5212 12.5835ZM33.4938 19.5232L24.5212 24.7014L15.5482 19.5232L24.5212 14.3427L33.4938 19.5232ZM14.7862 20.8424L23.7594 26.0208V36.3845L14.7862 31.2039V20.8424ZM25.2829 36.3845V26.0208L34.2558 20.8425V31.2039L25.2829 36.3845Z"
          fill="black"
          stroke="black"
          strokeWidth="0.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_675_6374">
          <rect
            width="26.6667"
            height="26.6667"
            fill="black"
            transform="translate(11.6667 12.1665)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export function TotalValidatorIcon() {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.500244"
        y="0.5"
        width="59"
        height="59"
        rx="29.5"
        fill="#FDFD1F"
        stroke="#FDFD1F"
      />
      <g clip-path="url(#clip0_836_8113)">
        <path
          d="M29.9598 29.7949C31.7058 28.7955 32.8989 26.9346 32.8989 24.7827C32.8989 21.5862 30.2983 18.9856 27.1018 18.9856C23.9052 18.9856 21.3047 21.5862 21.3047 24.7827C21.3047 26.9346 22.4977 28.7955 24.2438 29.7949C19.8763 30.9416 16.667 34.6343 16.667 39.0111V40.4349C16.667 40.7549 16.9267 41.0146 17.2467 41.0146C17.5667 41.0146 17.8264 40.7549 17.8264 40.4349V39.0111C17.8264 34.363 21.9876 30.5798 27.1018 30.5798C32.2159 30.5798 36.3771 34.363 36.3771 39.0111V40.4349C36.3771 40.7549 36.6369 41.0146 36.9569 41.0146C37.2769 41.0146 37.5366 40.7549 37.5366 40.4349V39.0111C37.5365 34.6343 34.3273 30.9404 29.9598 29.7949ZM22.4641 24.7827C22.4641 22.225 24.5441 20.1451 27.1018 20.1451C29.6594 20.1451 31.7394 22.225 31.7394 24.7827C31.7394 27.3404 29.6594 29.4204 27.1018 29.4204C24.5441 29.4204 22.4641 27.3404 22.4641 24.7827Z"
          fill="black"
        />
        <path
          d="M37.766 29.8099C39.0228 28.9786 39.8553 27.5572 39.8553 25.9421C39.8553 23.3844 37.7753 21.3044 35.2177 21.3044C34.8977 21.3044 34.6379 21.5642 34.6379 21.8842C34.6379 22.2042 34.8977 22.4639 35.2177 22.4639C37.1353 22.4639 38.6959 24.0245 38.6959 25.9422C38.6959 27.8598 37.1353 29.4204 35.2177 29.4204C34.8977 29.4204 34.6379 29.6801 34.6379 30.0001C34.6379 30.3201 34.8976 30.5798 35.2176 30.5798C39.0541 30.5798 42.1741 33.4632 42.1741 37.0087V38.116C42.1741 38.436 42.4339 38.6957 42.7539 38.6957C43.0739 38.6957 43.3336 38.436 43.3336 38.116V37.0087C43.3336 33.658 40.9962 30.8117 37.766 29.8099Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_836_8113">
          <rect
            width="26.6667"
            height="26.6667"
            fill="white"
            transform="translate(16.667 16.6667)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export function BackIcon() {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99414 13L3.49414 8.5L7.99414 4M4.11914 8.5H13.2441"
        stroke="var(--theme-text-primary)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function PrevIcon() {
  return (
    <svg
      viewBox="64 64 896 896"
      focusable="false"
      data-icon="double-left"
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z"></path>
    </svg>
  );
}
export function NextIcon() {
  return (
    <svg
      viewBox="64 64 896 896"
      focusable="false"
      data-icon="double-right"
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z"></path>
    </svg>
  );
}

export function MnemonicsIcon() {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.4764 6.68215L16.353 3.55872C15.993 3.19872 15.514 3 15.0042 3H9.15722C8.105 3 7.24849 3.85591 7.24849 4.90873V5.54899H6.60823C5.55782 5.54899 4.70312 6.40369 4.70312 7.45409V19.0949C4.70312 20.1453 5.55782 21 6.60823 21H15.5853C16.6357 21 17.4904 20.1453 17.4904 19.0949V18.4528H18.127C19.1786 18.4528 20.0345 17.5969 20.0345 16.5459V8.02973C20.0345 7.52839 19.831 7.03671 19.4764 6.68215ZM18.1765 6.92013H16.9286C16.4792 6.92013 16.1132 6.5547 16.1132 6.1047V4.85678L18.1765 6.92013ZM16.4031 19.0949C16.4031 19.5461 16.0365 19.9128 15.5853 19.9128H6.60823C6.15762 19.9128 5.79037 19.5461 5.79037 19.0949V7.45409C5.79037 7.00289 6.15702 6.63624 6.60823 6.63624H7.2491V16.5465C7.2491 17.5975 8.105 18.4528 9.15601 18.4528H16.4031V19.0949ZM18.9473 16.5459C18.9473 16.9983 18.58 17.3656 18.1276 17.3656H9.15601C8.7042 17.3656 8.33695 16.9983 8.33695 16.5465V4.90873C8.33695 4.4557 8.7048 4.08725 9.15782 4.08725H15.0048C15.0121 4.08725 15.0187 4.09148 15.0259 4.09148V6.1047C15.0259 7.15389 15.8794 8.00738 16.9286 8.00738H18.9425C18.9425 8.01523 18.9467 8.02188 18.9467 8.02973V16.5459H18.9473Z"
        fill="#0071FF"
        stroke="#0071FF"
        strokeWidth="0.2"
      />
      <path
        d="M10.695 10.6561H13.0422C13.3424 10.6561 13.5859 10.4127 13.5859 10.1125C13.5859 9.81227 13.3424 9.56885 13.0422 9.56885H10.695C10.3948 9.56885 10.1514 9.81227 10.1514 10.1125C10.1514 10.4127 10.3942 10.6561 10.695 10.6561Z"
        fill="#0071FF"
        stroke="#0071FF"
        strokeWidth="0.2"
      />
      <path
        d="M16.5893 12.1438H10.694C10.3938 12.1438 10.1504 12.3872 10.1504 12.6874C10.1504 12.9876 10.3938 13.231 10.694 13.231H16.5893C16.8895 13.231 17.1329 12.9876 17.1329 12.6874C17.1329 12.3872 16.8895 12.1438 16.5893 12.1438Z"
        fill="#0071FF"
        stroke="#0071FF"
        strokeWidth="0.2"
      />
      <path
        d="M15.3514 14.7188H10.695C10.3948 14.7188 10.1514 14.9622 10.1514 15.2624C10.1514 15.5626 10.3948 15.806 10.695 15.806H15.3514C15.6516 15.806 15.8951 15.5626 15.8951 15.2624C15.8951 14.9622 15.6516 14.7188 15.3514 14.7188Z"
        fill="#0071FF"
        stroke="#0071FF"
        strokeWidth="0.2"
      />
    </svg>
  );
}
export function DownIcon() {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.97075 0.719262L5.00075 3.68926L2.03075 0.719262C1.73775 0.426262 1.26275 0.426262 0.96975 0.719262C0.67675 1.01226 0.67675 1.48726 0.96975 1.78026L4.46975 5.28026C4.61575 5.42626 4.80775 5.50026 4.99975 5.50026C5.19175 5.50026 5.38375 5.42726 5.52975 5.28026L9.02975 1.78026C9.32275 1.48726 9.32275 1.01226 9.02975 0.719262C8.73675 0.426262 8.26175 0.426262 7.96875 0.719262H7.97075Z"
        fill="#565656"
      />
    </svg>
  );
}

export const YoutubeIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2589_516)">
        <path
          d="M29.4999 15C29.4999 23.0081 23.008 29.5 14.9999 29.5C6.99174 29.5 0.499878 23.0081 0.499878 15C0.499878 6.99187 6.99174 0.5 14.9999 0.5C23.008 0.5 29.4999 6.99187 29.4999 15Z"
          fill="#161616"
          stroke="#454545"
        />
        <path
          d="M14.9998 8.85852C15.6562 8.85852 16.3294 8.87541 16.982 8.90305L17.7527 8.93989L18.4905 8.98365L19.1814 9.03048L19.8124 9.07961C20.4973 9.13173 21.1419 9.42387 21.6325 9.90456C22.1232 10.3853 22.4285 11.0237 22.4947 11.7074L22.5254 12.0337L22.583 12.7322C22.6367 13.4562 22.6766 14.2453 22.6766 15C22.6766 15.7546 22.6367 16.5438 22.583 17.2677L22.5254 17.9663L22.4947 18.2926C22.4285 18.9764 22.1231 19.6149 21.6323 20.0956C21.1414 20.5763 20.4967 20.8684 19.8116 20.9203L19.1821 20.9687L18.4912 21.0163L17.7527 21.06L16.982 21.0969C16.3216 21.1255 15.6608 21.1403 14.9998 21.1414C14.3389 21.1403 13.678 21.1255 13.0177 21.0969L12.2469 21.06L11.5092 21.0163L10.8183 20.9687L10.1872 20.9203C9.5023 20.8682 8.85775 20.5761 8.36708 20.0954C7.87641 19.6147 7.57111 18.9763 7.50494 18.2926L7.47423 17.9663L7.41666 17.2677C7.35818 16.5132 7.32694 15.7568 7.323 15C7.323 14.2453 7.36292 13.4562 7.41666 12.7322L7.47423 12.0337L7.50494 11.7074C7.57108 11.0238 7.87627 10.3855 8.36679 9.9048C8.8573 9.42412 9.50167 9.1319 10.1864 9.07961L10.8167 9.03048L11.5076 8.98365L12.2461 8.93989L13.0169 8.90305C13.6775 8.87443 14.3386 8.85959 14.9998 8.85852ZM14.9998 10.3939C14.3665 10.3939 13.7147 10.4108 13.0806 10.4369L12.3298 10.473L11.609 10.5152L10.9319 10.5612L10.3116 10.6096C9.98547 10.6324 9.67801 10.7701 9.44384 10.9983C9.20968 11.2264 9.06397 11.5301 9.03262 11.8555C8.94281 12.7837 8.85836 13.939 8.85836 15C8.85836 16.0609 8.94281 17.2163 9.03262 18.1444C9.09788 18.8138 9.62911 19.3343 10.3116 19.3903L10.9319 19.4379L11.609 19.484L12.3298 19.527L13.0806 19.5631C13.7147 19.5892 14.3665 19.6061 14.9998 19.6061C15.6331 19.6061 16.2849 19.5892 16.919 19.5631L17.6698 19.527L18.3907 19.4848L19.0678 19.4387L19.688 19.3903C20.0142 19.3675 20.3216 19.2298 20.5558 19.0017C20.7899 18.7736 20.9357 18.4698 20.967 18.1444C21.0568 17.2163 21.1413 16.0609 21.1413 15C21.1413 13.939 21.0568 12.7837 20.967 11.8555C20.9357 11.5301 20.7899 11.2264 20.5558 10.9983C20.3216 10.7701 20.0142 10.6324 19.688 10.6096L19.0678 10.562L18.3907 10.5159L17.6698 10.473L16.919 10.4369C16.2796 10.4094 15.6398 10.3951 14.9998 10.3939ZM13.4644 13.1383C13.4644 13.0633 13.4827 12.9894 13.5177 12.9231C13.5527 12.8567 13.6034 12.7999 13.6654 12.7576C13.7274 12.7153 13.7987 12.6888 13.8733 12.6804C13.9478 12.6719 14.0233 12.6818 14.0932 12.7092L14.1554 12.7399L17.3796 14.6008C17.4438 14.6378 17.4981 14.6898 17.538 14.7523C17.5778 14.8149 17.6019 14.8861 17.6083 14.9599C17.6147 15.0338 17.6032 15.1081 17.5748 15.1765C17.5463 15.245 17.5017 15.3056 17.4449 15.3531L17.3796 15.3992L14.1554 17.2608C14.0904 17.2984 14.0172 17.3196 13.9422 17.3225C13.8671 17.3253 13.7926 17.3098 13.7249 17.2773C13.6572 17.2447 13.5985 17.1961 13.554 17.1357C13.5094 17.0753 13.4802 17.0049 13.4691 16.9307L13.4644 16.8616V13.1383Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2589_516">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CmcIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2589_528)">
        <path
          d="M29.5 15C29.5 23.0081 23.0081 29.5 15 29.5C6.99187 29.5 0.5 23.0081 0.5 15C0.5 6.99187 6.99187 0.5 15 0.5C23.0081 0.5 29.5 6.99187 29.5 15Z"
          fill="#161616"
          stroke="#454545"
        />
        <path
          d="M20.4382 16.4569C20.1775 16.6219 19.8707 16.6424 19.6379 16.5111C19.3417 16.343 19.1786 15.9522 19.1786 15.407V13.7778C19.1786 12.9911 18.8674 12.431 18.3472 12.2798C17.4659 12.0228 16.8025 13.1013 16.5536 13.507L14.999 16.0275V12.9469C14.9816 12.2375 14.7513 11.8137 14.3144 11.6855C14.0244 11.6015 13.5919 11.6351 13.1712 12.2786L9.68796 17.8715C9.22225 16.986 8.97917 16.0005 8.97974 15C8.97974 11.6307 11.6801 8.88992 14.999 8.88992C18.3173 8.88992 21.017 11.6307 21.017 15C21.0195 15.0112 21.0182 15.0212 21.0189 15.033C21.05 15.6859 20.8384 16.2049 20.4382 16.4582V16.4569ZM22.355 15.0007L22.3544 14.9664C22.3357 10.8634 19.0436 7.53198 14.9984 7.53198C10.9426 7.53198 7.64233 10.882 7.64233 15C7.64233 19.1174 10.9426 22.4681 14.9984 22.4681C16.8598 22.4681 18.6366 21.7605 20.0001 20.4766C20.2708 20.2215 20.2864 19.792 20.0356 19.5176C19.9764 19.4523 19.9048 19.3995 19.825 19.3622C19.7451 19.325 19.6587 19.304 19.5706 19.3006C19.4826 19.2972 19.3947 19.3114 19.3123 19.3423C19.2298 19.3733 19.1543 19.4204 19.0902 19.4809C17.9851 20.5273 16.5209 21.1103 14.999 21.1102C13.2216 21.1102 11.6228 20.3241 10.52 19.0764L13.6616 14.0323V16.358C13.6616 17.4745 14.0947 17.8354 14.4582 17.9412C14.8216 18.047 15.3768 17.9748 15.9599 17.0276C16.581 16.0232 17.2201 14.9758 17.8412 13.9906V15.407C17.8412 16.4513 18.2594 17.2865 18.9882 17.6973C19.6454 18.0688 20.4718 18.0352 21.1446 17.6101C21.9611 17.0948 22.4005 16.1451 22.3544 15.0007H22.355Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2589_528">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LinkedinIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="14.5" fill="#161616" stroke="#454545" />

      <path
        d="M10.5 12.75H13.125V21H10.5V12.75ZM11.8125 8.625C12.641 8.625 13.3125 9.29657 13.3125 10.125C13.3125 10.9534 12.641 11.625 11.8125 11.625C10.9841 11.625 10.3125 10.9534 10.3125 10.125C10.3125 9.29657 10.9841 8.625 11.8125 8.625Z"
        fill="white"
      />

      <path
        d="M14.625 12.75H17.1375V13.875H17.175C17.525 13.2125 18.3813 12.4875 19.65 12.4875C22.3125 12.4875 22.8 14.2438 22.8 16.5313V21H20.175V17.0375C20.175 16.0938 20.1563 14.8875 18.8625 14.8875C17.55 14.8875 17.35 15.9125 17.35 16.9688V21H14.725L14.625 12.75Z"
        fill="white"
      />
    </svg>
  );
};
export const LoaderDots = () => {
  return (
    <svg
      width="80"
      height="40"
      viewBox="0 0 120 30"
      xmlns="http://www.w3.org/2000/svg"
      fill="#FDFD1F"
    >
      <circle cx="15" cy="15" r="15">
        <animate
          attributeName="r"
          from="15"
          to="15"
          begin="0s"
          dur="0.8s"
          values="15;9;15"
          calcMode="linear"
          repeatCount="indefinite"
        />
        <animate
          attributeName="fill-opacity"
          begin="0s"
          dur="0.8s"
          values="1;.5;1"
          calcMode="linear"
          repeatCount="indefinite"
        />
      </circle>
      <circle cx="60" cy="15" r="9" fill-opacity="0.3">
        <animate
          attributeName="r"
          from="9"
          to="9"
          begin="0.2s"
          dur="0.8s"
          values="9;15;9"
          calcMode="linear"
          repeatCount="indefinite"
        />
        <animate
          attributeName="fill-opacity"
          begin="0.2s"
          dur="0.8s"
          values=".5;1;.5"
          calcMode="linear"
          repeatCount="indefinite"
        />
      </circle>
      <circle cx="105" cy="15" r="15">
        <animate
          attributeName="r"
          from="15"
          to="15"
          begin="0.4s"
          dur="0.8s"
          values="15;9;15"
          calcMode="linear"
          repeatCount="indefinite"
        />
        <animate
          attributeName="fill-opacity"
          begin="0.4s"
          dur="0.8s"
          values="1;.5;1"
          calcMode="linear"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  );
};
export const MonitorIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#51a2ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-monitor w-10 h-10 text-blue-400" aria-hidden="true"><rect width="20" height="14" x="2" y="3" rx="2"></rect><line x1="8" x2="16" y1="21" y2="21"></line><line x1="12" x2="12" y1="17" y2="21"></line></svg>
  );
};
export const UserCircleIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#c27aff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-user w-10 h-10 text-purple-400" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="10" r="3"></circle><path d="M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662"></path></svg>);
};
export const CoinsIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#00d492" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-coins w-10 h-10 text-emerald-400" aria-hidden="true"><circle cx="8" cy="8" r="6"></circle><path d="M18.09 10.37A6 6 0 1 1 10.34 18"></path><path d="M7 6h1v4"></path><path d="m16.71 13.88.7.71-2.82 2.82"></path></svg>);
};
export const WalletLoginIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#51a2ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-wallet w-4 h-4 text-blue-400" aria-hidden="true"><path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1"></path><path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4"></path></svg>);
};
export const ShieldIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#51a2ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shield w-4 h-4 text-blue-400" aria-hidden="true"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path></svg>);
};
export const LayoutDashboardIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#51a2ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-layout-dashboard w-4 h-4 text-blue-400" aria-hidden="true"><rect width="7" height="9" x="3" y="3" rx="1"></rect><rect width="7" height="5" x="14" y="3" rx="1"></rect><rect width="7" height="9" x="14" y="12" rx="1"></rect><rect width="7" height="5" x="3" y="16" rx="1"></rect></svg>);
};
export const GlobeIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#c27aff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-globe w-4 h-4 text-purple-400" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path><path d="M2 12h20"></path></svg>);
};
export const LockIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#c27aff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-lock w-4 h-4 text-purple-400" aria-hidden="true"><rect width="18" height="11" x="3" y="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>);
};
export const TrendingUpIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#00d492" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trending-up w-4 h-4 text-emerald-400" aria-hidden="true"><path d="M16 7h6v6"></path><path d="m22 7-8.5 8.5-5-5L2 17"></path></svg>);
};
export const RocketIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#00d492" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-rocket w-4 h-4 text-emerald-400" aria-hidden="true"><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"></path><path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"></path><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"></path><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"></path></svg>);
};
export const ExternalLink = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#99a1af" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-external-link w-3 h-3" aria-hidden="true"><path d="M15 3h6v6"></path><path d="M10 14 21 3"></path><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path></svg>);
};

export const LogoutIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" y1="12" x2="9" y2="12" />
    </svg>
  );
};

export const ManageAccIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
};

export const WalletIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
    >
      <path d="M21 12V7H5a2 2 0 0 1 0-4h14v2" />
      <path d="M3 5v14a2 2 0 0 0 2 2h16v-5" />
      <path d="M18 12a2 2 0 0 0 0 4h4v-4Z" />
    </svg>
  );
};

export const ChevronDownIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="6 9 12 15 18 9" />
    </svg>
  );
};

export const AvatarIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  );
};

export const BlockValidationIcon = () => {
  return (
    <svg width="48" height="49" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="100" cy="100" r="100" fill="#fdfd1f"></circle>

      <g stroke="#0b1f2a" stroke-width="7" stroke-linecap="round" stroke-linejoin="round">
        <path d="M100 40 L155 70 L100 100 L45 70 Z"></path>
        <path d="M45 70 L45 125 L100 155 L100 100 Z"></path>
        <path d="M155 70 L155 125 L100 155 L100 100 Z"></path>
      </g>
    </svg>
  );
};

export const ValidationIcon = () => {
  return (
    <svg width="49" height="49" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="100" cy="100" r="100" fill="#fdfd1f"></circle>

      <g stroke="#0b1f2a" stroke-width="6.5" stroke-linecap="round" stroke-linejoin="round">

        <rect x="60" y="60" width="80" height="80" rx="10"></rect>

        <rect x="80" y="80" width="40" height="40" rx="6"></rect>

        <line x1="80" y1="40" x2="80" y2="60"></line>
        <line x1="100" y1="40" x2="100" y2="60"></line>
        <line x1="120" y1="40" x2="120" y2="60"></line>

        <line x1="80" y1="140" x2="80" y2="160"></line>
        <line x1="100" y1="140" x2="100" y2="160"></line>
        <line x1="120" y1="140" x2="120" y2="160"></line>

        <line x1="40" y1="80" x2="60" y2="80"></line>
        <line x1="40" y1="100" x2="60" y2="100"></line>
        <line x1="40" y1="120" x2="60" y2="120"></line>

        <line x1="140" y1="80" x2="160" y2="80"></line>
        <line x1="140" y1="100" x2="160" y2="100"></line>
        <line x1="140" y1="120" x2="160" y2="120"></line>

      </g>
    </svg>
  );
};

export const RewardIcon = () => {
  return (
    <svg width="49" height="49" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="100" cy="100" r="100" fill="#fdfd1f"></circle>

      <g stroke="#0b1f2a" stroke-width="6.5" stroke-linecap="round" stroke-linejoin="round">
        <rect x="52" y="78" width="96" height="24" rx="6"></rect>

        <rect x="52" y="102" width="96" height="52" rx="6"></rect>

        <path d="M100 78V154"></path>

        <path d="M92 78C82 78 74 72 74 64C74 58 78 54 84 54C92 54 98 62 100 78"></path>

        <path d="M108 78C118 78 126 72 126 64C126 58 122 54 116 54C108 54 102 62 100 78"></path>
      </g>
    </svg>
  );
};

export const CloseIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true" focusable="false">
    <path d="M4 4l10 10M14 4L4 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const WarningIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

export const CrownSvg = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="m2 4 3 12h14l3-12-6 7-4-7-4 7-6-7zm3 16h14" />
  </svg>
);

export const CheckCircleSvg = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="m9 12 2 2 4-4" />
  </svg>
);

export const CheckmarkSvg = ({ className = undefined }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="4"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const classNamePropType = { className: PropTypes.string };
CrownSvg.propTypes = classNamePropType;
CheckCircleSvg.propTypes = classNamePropType;
CheckmarkSvg.propTypes = classNamePropType;
